module.exports = __webpack_public_path__ + "img/e4.8190f277.jpg";